<p-dialog
	[header]="translateServ.dictionary['SETTINGS_TITLE'] || 'Settings'"
	[(visible)]="dialogVisible"
	[modal]="true"
	appendTo="body"
	[closable]="true"
	styleClass="settings-dialog"
	[style]="{ width: '900px', maxWidth: '95vw' }"
	[contentStyle]="{ padding: '0', height: '65vh' }"
	(onHide)="goBack()"
>
	<ng-container *ngIf="previewToastVisible">
		<p-toast key="settingsPreview" [position]="settings().notificationPosition"></p-toast>
	</ng-container>

	<div class="settings-dialog-body flex h-full">
		<!-- Category nav (IntelliJ/SAP-style left list) -->
		<div class="settings-nav w-56 shrink-0 border-r border-surface-200 dark:border-surface-700 py-2 overflow-y-auto">
			<button
				type="button"
				*ngFor="let cat of categories"
				class="settings-nav-item w-full text-left flex items-center gap-2 px-3 py-2"
				[class.active]="activeCategory === cat.id"
				(click)="activeCategory = cat.id"
			>
				<i [class]="cat.icon"></i>
				<span>{{ translateServ.dictionary['SETTINGS_CAT_' + cat.id.toUpperCase()] || cat.label }}</span>
			</button>
		</div>

		<!-- Category content -->
		<div class="settings-content flex-1 overflow-y-auto p-4">
			<ng-container [ngSwitch]="activeCategory">
				<!-- Notifications -->
				<div *ngSwitchCase="'notifications'" class="flex flex-col gap-4">
					<div>
						<div class="font-medium mb-2">{{ translateServ.dictionary['SETTINGS_NOTIF_SIZE'] || 'Size' }}</div>
						<p-selectbutton [ngModel]="settings().notificationSize" (ngModelChange)="setNotificationSize($event)" [options]="notificationSizeOptions" optionLabel="label" optionValue="value" size="small"></p-selectbutton>
					</div>
					<div>
						<div class="font-medium mb-2">{{ translateServ.dictionary['SETTINGS_NOTIF_POSITION'] || 'Position' }}</div>
						<p-selectbutton [ngModel]="settings().notificationPosition" (ngModelChange)="setNotificationPosition($event)" [options]="notificationPositionOptions" optionLabel="label" optionValue="value" size="small"></p-selectbutton>
					</div>
					<div class="flex items-center justify-between">
						<span>{{ translateServ.dictionary['SETTINGS_NOTIF_BLINK'] || 'Enable blinking notifications' }}</span>
						<p-toggleswitch [ngModel]="settings().notificationBlinking" (ngModelChange)="setNotificationBlinking($event)"></p-toggleswitch>
					</div>

					<div class="app-notif-preview p-toast-message p-toast-message-warn" [class.blinking-warning]="settings().notificationBlinking" role="alert">
						<div class="p-toast-message-content">
							<span class="p-toast-message-icon pi pi-exclamation-triangle" aria-hidden="true"></span>
							<div class="p-toast-message-text">
								<div class="app-notif-preview-title p-toast-summary">{{ translateServ.dictionary['SETTINGS_NOTIF_PREVIEW_TITLE'] || 'Preview' }}</div>
								<div class="app-notif-preview-detail p-toast-detail">{{ translateServ.dictionary['SETTINGS_NOTIF_PREVIEW_DETAIL'] || 'This is how notifications will look.' }}</div>
							</div>
							<div>
								<button type="button" class="p-toast-close-button" tabindex="-1" style="pointer-events: none;" aria-hidden="true">
									<span class="p-toast-close-icon pi pi-times"></span>
								</button>
							</div>
						</div>
					</div>
					<div class="flex align-items-center gap-2">
						<span class="text-muted-color text-sm">{{ translateServ.dictionary['SETTINGS_NOTIF_TAG_PREVIEW'] || 'Notification badge size:' }}</span>
						<p-tag class="app-notif-tag" severity="warn" [value]="translateServ.dictionary['SETTINGS_NOTIF_TAG'] || 'Unresolved'"></p-tag>
					</div>

					<p-button [label]="translateServ.dictionary['SETTINGS_NOTIF_TEST'] || 'Show test notification'" icon="pi pi-bell" styleClass="p-button-outlined w-max" (click)="showTestNotification()"></p-button>
				</div>

				<!-- Display -->
				<div *ngSwitchCase="'display'" class="flex flex-col gap-4">
					<div>
						<div class="font-medium mb-2">{{ translateServ.dictionary['SETTINGS_FONT_SCALE'] || 'Font Size' }}</div>
						<p-selectbutton [ngModel]="settings().fontScale" (ngModelChange)="setFontScale($event)" [options]="fontScaleOptions" optionLabel="label" optionValue="value" size="small"></p-selectbutton>
					</div>
					<div>
						<div class="font-medium mb-2">{{ translateServ.dictionary['SETTINGS_MOTION'] || 'Animations' }}</div>
						<p-selectbutton [ngModel]="settings().motion" (ngModelChange)="setMotion($event)" [options]="motionOptions" optionLabel="label" optionValue="value" size="small"></p-selectbutton>
					</div>

					<div class="border border-surface-200 dark:border-surface-700 rounded-md p-3">
						<div class="font-medium mb-2">{{ translateServ.dictionary['SETTINGS_MOTION_PREVIEW'] || 'Preview' }}</div>
						<div class="flex items-center gap-3">
							<p-button [label]="translateServ.dictionary['SETTINGS_MOTION_PLAY'] || 'Play animation'" icon="pi pi-play" styleClass="p-button-outlined p-button-sm" (click)="toggleMotionDemo()"></p-button>
							<div class="motion-demo-track relative w-40 h-8 border border-surface-200 dark:border-surface-700 rounded-full">
								<div class="motion-demo-dot absolute top-1 left-1 w-6 h-6 rounded-full bg-primary" [class.moved]="motionDemoMoved"></div>
							</div>
							<span class="text-muted-color text-sm">{{ translateServ.dictionary['SETTINGS_MOTION_' + settings().motion.toUpperCase()] || settings().motion }}</span>
						</div>
					</div>

					<div class="border border-surface-200 dark:border-surface-700 rounded-md p-3">
						<div class="text-xl font-bold">{{ translateServ.dictionary['SETTINGS_SAMPLE_HEADING'] || 'Sample Heading' }}</div>
						<p class="text-muted-color">{{ translateServ.dictionary['SETTINGS_SAMPLE_TEXT'] || 'Sample paragraph text reflecting the current font size setting.' }}</p>
					</div>

					<div class="flex items-center justify-between">
						<span>{{ translateServ.dictionary['SETTINGS_COMPACT_SPACING'] || 'Compact spacing' }}</span>
						<p-toggleswitch [ngModel]="settings().compactSpacing" (ngModelChange)="setCompactSpacing($event)"></p-toggleswitch>
					</div>
					<div class="flex items-center justify-between">
						<span>{{ translateServ.dictionary['SETTINGS_HIGH_CONTRAST'] || 'High contrast' }}</span>
						<p-toggleswitch [ngModel]="settings().highContrast" (ngModelChange)="setHighContrast($event)"></p-toggleswitch>
					</div>
				</div>

				<!-- Language -->
				<div *ngSwitchCase="'language'" class="flex flex-col gap-4">
					<div>
						<div class="font-medium mb-2">{{ translateServ.dictionary['SETTINGS_LANGUAGE_SELECT'] || 'Application language' }}</div>
						<p-selectbutton [ngModel]="currentLang" (ngModelChange)="changeLanguage($event)" [options]="languageOptions" optionLabel="label" optionValue="value" size="small"></p-selectbutton>
					</div>
					<p class="text-muted-color text-sm">{{ translateServ.dictionary['SETTINGS_LANGUAGE_NOTE'] || 'Text direction (LTR/RTL) switches automatically with the selected language.' }}</p>
				</div>

				<!-- Tables -->
				<div *ngSwitchCase="'tables'" class="flex flex-col gap-4">
					<div>
						<div class="font-medium mb-2">{{ translateServ.dictionary['SETTINGS_TABLE_DENSITY'] || 'Row density' }}</div>
						<p-selectbutton [ngModel]="settings().tableDensity" (ngModelChange)="setTableDensity($event)" [options]="tableDensityOptions" optionLabel="label" optionValue="value" size="small"></p-selectbutton>
					</div>
					<div class="flex items-center justify-between">
						<span>{{ translateServ.dictionary['SETTINGS_TABLE_GRIDLINES'] || 'Show gridlines' }}</span>
						<p-toggleswitch [ngModel]="settings().tableGridlines" (ngModelChange)="setTableGridlines($event)"></p-toggleswitch>
					</div>

					<p-table [value]="previewTableRows" styleClass="app-data-table">
						<ng-template pTemplate="header">
							<tr>
								<th>{{ translateServ.dictionary['SETTINGS_PREVIEW_NAME'] || 'Name' }}</th>
								<th>{{ translateServ.dictionary['SETTINGS_PREVIEW_STATUS'] || 'Status' }}</th>
							</tr>
						</ng-template>
						<ng-template pTemplate="body" let-row>
							<tr>
								<td>{{ row.name }}</td>
								<td>{{ row.status }}</td>
							</tr>
						</ng-template>
					</p-table>
				</div>

				<!-- Diagnostics -->
				<div *ngSwitchCase="'diagnostics'" class="flex flex-col gap-4">
					<div>
						<div class="font-medium mb-2">{{ translateServ.dictionary['SETTINGS_SEED_TITLE'] || 'Settings Seed' }}</div>
						<p class="text-muted-color text-sm mb-2">{{ translateServ.dictionary['SETTINGS_SEED_HINT'] || 'Share this code with support so your exact settings can be reproduced.' }}</p>
						<div class="flex gap-2">
							<input type="text" pInputText readonly [value]="currentSeed" class="flex-1" />
							<p-button icon="pi pi-copy" [label]="translateServ.dictionary['SETTINGS_SEED_COPY'] || 'Copy'" styleClass="p-button-outlined" (click)="copySeed()"></p-button>
						</div>
					</div>

					<div>
						<div class="font-medium mb-2">{{ translateServ.dictionary['SETTINGS_SEED_APPLY_TITLE'] || 'Apply a Seed' }}</div>
						<div class="flex gap-2">
							<input
								type="text"
								pInputText
								[(ngModel)]="seedInput"
								class="flex-1"
								[placeholder]="translateServ.dictionary['SETTINGS_SEED_PLACEHOLDER'] || 'Paste a settings seed here'"
							/>
							<p-button icon="pi pi-check" [label]="translateServ.dictionary['SETTINGS_SEED_APPLY_BTN'] || 'Apply'" styleClass="p-button-outlined" (click)="applySeedInput()"></p-button>
						</div>
						<p class="text-red-500 text-sm mt-1" *ngIf="seedApplyError">{{ translateServ.dictionary['SETTINGS_SEED_INVALID'] || 'That seed could not be read.' }}</p>
					</div>
				</div>
			</ng-container>
		</div>
	</div>

	<ng-template pTemplate="footer">
		<p-button [label]="translateServ.dictionary['SETTINGS_RESET'] || 'Reset to Defaults'" icon="pi pi-refresh" styleClass="p-button-outlined p-button-secondary" (click)="resetToDefaults()"></p-button>
		<p-button [label]="translateServ.dictionary['SETTINGS_CLOSE'] || 'Close'" icon="pi pi-check" (click)="dialogVisible = false"></p-button>
	</ng-template>
</p-dialog>
